<template>
  <van-popup v-model="isShowVedio" class="food-box">
    <!-- 返回按钮 -->
    <div :class="onlyVideo ? 'height' : ''" class="childVideo">
      <div class="gobackBtn" @click="goBack">
        <img alt src="@/assets/images/icon/back1.png"/>
      </div>
      <!-- 点赞收藏分享 -->
      <commonent
          v-if="!isCommonPopup"
          :articalId="videoDetail.id"
          :carrierId="carrierId"
          :isGoLogin="isGoLogin"
          :videoDetail="videoDetail"
          @share="share"
          @showComment="showComment"
      />
      <!-- 视频标题 -->
      <div class="introduce">
        <p>{{ videoDetail.name || videoDetail.recipeName }}</p>
      </div>
      <!-- 评论框 -->
      <van-popup
          v-model="showAllComment"
          :style="{ height: '50%' }"
          class="anchor"
          get-container="food-box"
          position="bottom"
          round
          @click-overlay="close"
      >
        <!-- 京城名医评论组件 -->
        <div v-if="carrierId == '10'">
          <comment-field
              ref="focus"
              :articalId="videoDetail.id"
              :carrierId="carrierId"
              :isGoLogin="isGoLogin"
              :title="videoDetail.name"
              :videolike="{ isLike: false, videolikes: 1 }"
              @getAllComment="getAllComment"
          >
          </comment-field>
          <all-comment
              ref="allComment"
              :articalId="videoDetail.id"
              :carrierId="carrierId"
              :isGoLogin="isGoLogin"
              :title="videoDetail.name"
              @focusOn="getFocusOn"
              @toReplyCom="toReplyCom"
              @type="getType"
          ></all-comment>
        </div>
        <!-- 辅食评论组件 -->
        <div v-else>
          <foodCommentField
              ref="focus"
              :Info="videoDetail"
              :articalId="videoDetail.id"
              :carrierId="carrierId"
              :foodSendImg="foodInitImg"
              :isGoLogin="isGoLogin"
              :title="videoDetail.recipeName"
              @clearPic="clearcommentPic"
              @focusOn="getFocusOn"
              @getAllComment="getAllComment"
              @sendPiclen="getPiclen"
              @sendUpload="getUpimg"
              @type="getType"
          ></foodCommentField>
          <foodAllComment
              ref="allComment"
              :articalId="videoDetail.id"
              :carrierId="carrierId"
              :isGoLogin="isGoLogin"
              :title="videoDetail.name"
              @comTotal="comTotal"
              @focusOn="getFocusOn"
              @toReplyCom="toReplyCom"
              @type="getType"
          ></foodAllComment>
        </div>
      </van-popup>
      <!-- 西瓜视频DOM Begin -->
      <Xgplayer
          id="child"
          ref="Xgplayer"
          :class="startStyle"
          :config="Videoconfig"
          playsinline
          webkit-playsinline
          x5-playsinline
          @player="Player = $event"
          @touchstart.native="touchstart"
          @touchmove.native="touchmove"
      />
      <van-dialog
          v-if="masterrule"
          v-model="showExchangePoint"
          :before-close="payPointConfirm"
          :message="
          `${
            videoDetail.pageCumulativeNum > 0
              ? '已有' + videoDetail.pageCumulativeNum + '星妈兑换成功'
              : ''
          }`
        "
          :title="
          `是否确认使用${Integral}积分兑换&quot;${
            videoDetail.name
          }&quot;课程观看完整版视频`
        "
          confirm-button-color="#F1BA3B"
          show-cancel-button
      ></van-dialog>
    </div>
    <!-- 分享 -->
    <HFshare ref="HFshareVideo"></HFshare>
  </van-popup>
</template>

<script>
import Xgplayer from "xgplayer-vue";
import HFshare from "@/components/comment/share.vue";
import {addIntegral, inquireTime} from "@/utils/newMemberApiGlobal"
import * as until from "@/assets/js/common.js"; //公共方法
import {Debounce, getCookie, isUserLogin} from "@/assets/js/common.js";
import allComment from "@/components/comment/allComment.vue"; //评论组件
import commentField from "@/components/comment/commentField.vue"; // 输入框组件
import foodAllComment from "@/views/contents/foodColumn/component/allcomment.vue"; //辅食评论组件
import foodCommentField from "@/views/contents/foodColumn/component/commentField.vue"; // 辅食输入框组件
import commonent from "./comment.vue";
import API from "@/utils/axiosApi/foodApi.js";
import API_ from "@/utils/axiosApi/catipaldoctorApi"; //api
export default {
  name: "childVideo",
  data() {
    return {
      currentTimebug: 0,
      Videoconfig: {}, //播放器配置
      Player: null, //播放器实例
      isShare: false, //是否显示分享
      isWifi: true, //判断网络是否为wifi / 是WIFI:true  / 4G:false
      videoShow: false,
      // isAdd: true, //解决全屏添加积分进入继续加
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      carrierId: "",
      showAllComment: false, //控制评论显示
      isShowVedio: this.showVedio,
      showExchangePoint: false, //支付积分弹窗
      isBuy: false, //是否播放试看视频
      masterrule: [], //会员等级
      // 营养厨房上传图片
      foodInitImg: [], //图片数组
      total: 3, //上传图片剩余数量
      len: 3, //上传图片总数
      readingArticleDuration: 10,
      Integral:'' //等级对应优惠的积分
    };
  },

  props: ["videoDetail", "videoId", "isVideoState", "onlyVideo", "showVedio", "isCommonPopup"],
  watch: {
    currentTimebug(val) {
      // console.log(Math.floor($("video")[0].duration));
      if (val == this.readingArticleDuration) {
        this.addGroth()
      }
      // 视频观看完成通知后台观看完成
      if (val == Math.floor($("video")[0].duration)) {
        // 视频观看完成请求后台
        API.addPlayVideoNum(
          {},
          { id: this.videoDetail.id, recordType: "4", moduleType: "5" },
          (res) => {}
        );
      }
    },
    /**
     * @description: 用于监听父级组件传过数据重新创建视频标签
     * @param {type} urlVideo 视频详情信息
     */
    videoDetail: {
      immediate: true, //这句重要
      deep: true, //深监听
      handler(newValue, oldValue) {
        console.log(newValue);
        var deeplink_url = window.location.href; //获取当前链接
        if (deeplink_url.indexOf("?") != -1) {
          deeplink_url = deeplink_url + "&";
        } else {
          deeplink_url = deeplink_url + "?";
        }
        // 判断音频播放在修改分享值
        if (newValue.id) {
          var shareDataParams = {
            shareLink:
                deeplink_url +
                "videoId=" +
                newValue.id +
                "&isFood=" +
                (newValue.isFood ? newValue.isFood : ""),
            shareDesc: newValue.name || newValue.recipeName,
            shareTitle: "星妈会-星专家",
            imgUrl: "https://image-mom.feihe.com/wxshare/home.png", //必须是绝对路径
          };
        }

        this.wxJsSet.wxShare("fx", shareDataParams, this);
        console.log(shareDataParams);
        /**
         * @description: nextTick用于让Dom加载完再调用视频创建方法，解决视频拿不到Dom白屏问题；
         * @param {type} newValue 视频详情信息
         */
        if (newValue) {
          // 7 营养厨房 10 京城名医
          if (newValue.isFood) {
            this.carrierId = "7";
          } else {
            this.carrierId = "10";
          }
          // this.masterrule = {
          //   "1": newValue.goidIntegral,
          //   "31": newValue.platinumIntegral,
          //   "35": newValue.diamondIntegral,
          // };
          this.Integral = newValue.integral
          if (this.$store.state.isWifi) {
            this.isWifi = this.$store.state.isWifi;
          } else {
            this.isWifiFun();
          }
          if (oldValue) {
            if (newValue.id !== oldValue.id) {
              this.$nextTick(function () {
                this.createVideo(newValue);
              });
            }
          }
        }
      },
    },
    isVideoState(val) {
      if (!val && $(".childVideo")) {
        $("video").off("timeupdate");
        $(".childVideo").css("display", "none");
      }
    },
    showVedio(val) {
      this.isShowVedio = val;
    },
  },
  created() {
    inquireTime(data => {
      this.readingArticleDuration = data.readingArticleDuration
    }, this)
  },
  mounted() {
  },
  computed: {
    // 计算视频带不带播放按钮
    startStyle() {
      if (!this.isWifi && !this.videoDetail) {
        return "xgplayer xgplayer-mobile xgplayer-skin-default lang-is-en  xgplayer-playing xgplayer-inactive xgplayer-pause videoDisPlayer";
      } else {
        return "xgplayer xgplayer-mobile xgplayer-skin-default xgplayer-pause  lang-is-en xgplayer-playing";
      }
    },
    isGoLogin() {
      return until.isUserLogin();
    },
  },
  methods: {
    fomatterNum: until.fomatterNum,
    getmotherState: until.getmotherState,
    // 分享弹窗
    share: function () {
      this.$refs.HFshareVideo.showShareVideo();
    },
    close() {
      this.showAllComment = false;
      $(".van-overlay").css({display: "none"});
    },
    toReplyCom(item) {
      $(".van-overlay").css({display: "none"});
      // this.$parent.showVedio = true
    },
    // 切换视频
    touchmove: Debounce(function (e) {
      // 判断默认行为是否可以被禁用
      if (e.cancelable) {
        // 判断默认行为是否已经被禁用
        if (!e.defaultPrevented) {
          e.preventDefault();
        }
      }
      // var moveEndX = e.changedTouches[0].pageX
      var moveEndY = e.changedTouches[0].pageY;
      // var X = moveEndX - this.startX
      var Y = moveEndY - this.startY;
      console.log(Y);
      //下滑 上一个 isPromotional是否是宣传视频 宣传视频唯一id标识
      if (Y > 150) {
        this.$emit(
            "switchoverVideoPrev",
            this.videoDetail.isPromotional ? "999" : this.videoDetail.id
        );
      }
      //上滑  下一个
      else if (Y < -150 && Y != 0) {
        // this.$emit(
        //   "switchoverVideoNext",
        //   this.videoDetail.isPromotional ? "999" : this.videoDetail.id
        // );
      }
      //单击
      else {
        // alert("单击");
      }
    }, 500),
    touchstart(e) {
      // 判断默认行为是否可以被禁用
      if (e.cancelable) {
        // 判断默认行为是否已经被禁用
        if (!e.defaultPrevented) {
          // e.preventDefault();
        }
      }
      this.startX = event.changedTouches[0].pageX;
      this.startY = event.changedTouches[0].pageY;
    },
    // 获取评论
    getAllComment(data) {
      // const { page, size, status } = data;
      // this.$refs.allComment.getAllComment(page, size, status);
      this.videoDetail.commentNum = ++this.videoDetail.commentNum;
    },
    getType(type) {
      this.$refs.focus.type = type;
    },
    getFocusOn(bool) {
      this.$refs.focus.isFocus = bool;
    },
    showComment() {
      this.showAllComment = true;
    },
    // 未登录10s
    listenLogin() {
      this.$emit("isUserLogin");
    },

    isLogin() {
      // var deeplink_url = window.location.href; //获取当前链接
      // if (deeplink_url.indexOf("?") != -1) {
      //   deeplink_url = deeplink_url + "&";
      // } else {
      //   deeplink_url = deeplink_url + "?";
      // }
      // deeplink_url = deeplink_url + "loginTypeId=15";
      // console.log(deeplink_url)
      // this.$router.push({
      //   path: "/phoneLogin?redirect=" + window.location.href,
      // });
      until.globalGoLogin()
      if (this.videoDetail.id) {
        switch (this.$route.name) {
          case "home":
            sessionStorage.setItem("homeLoginJumpVideoId", this.videoDetail.id);
            break;
          case "bjDoctor":
            sessionStorage.setItem(
                "bjDoctorLoginJumpVideoId",
                this.videoDetail.id
            );
            break;
          default:
        }
      }
    },
    goBack() {
      this.Player.pause();
      this.$emit("hideVedio");
      this.$parent.playIndex = 0;
    },
    /**
     * @description:创建视频实例
     * @param {type} newValue 视频详情配置
     */
    createVideo(newValue) {
      const { contentPayUrl, contentUrl, imgUrl } = newValue;
      if (contentPayUrl) {
        this.isBuy = true;
      } else {
        this.isBuy = false;
      }
      let self = this;
      // 安卓下不显示视频控件
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端

      // 视频切换为防止重新创建Dom
      // 背景图取消
      $("#child").css("background-image", "");
      // this.videoDetail.playState=true;
      // 关闭上次监听视频播放的时间
      $("video").off("timeupdate");
      // 如果有视频实例则不需要重新创建，直接切换地址
      if (this.Player) {
        // 切换视频地址
        this.Player.src = this.isBuy ? contentPayUrl : contentUrl;
        // 切换视频封面
        // this.Player.poster = imgUrl;
        // 判断是不是带锁，是不是4G网络如果是
        this.Player.start(this.isBuy ? contentPayUrl : contentUrl);
        this.Player.play();
        this.setPlayerVideo(self, isAndroid, true);
      } else {
        // 播放器配置
        this.Videoconfig = {
          id: "child", //元素id
          url: this.isBuy ? contentPayUrl : contentUrl, //视频地址
          poster: imgUrl, //图片
          fitVideoSize: "fixWidth",
          fitVideoSize: "fixHeight",
          playsinline: true, //设置ios全屏问题
          "x5-video-player-type": "h5", //解决ios安卓播放自动全屏问题
          "x5-video-player-fullscreen": false, //解决自动全屏问题
          "x5-video-orientation": "portraint", //横竖屏
          closeVideoClick: true, //禁止pc点击屏幕暂停（功能与现实相反）
          closeVideoTouch: true, //禁止手机点击屏幕暂停（功能与现实相反）
          ignores: ["enter", "mobile", "error"], //去掉loadding
          // loop: true, //循环播放
          whitelist: ["iPhone", "Android"], //白名单（支持个别机型）
          hasStart: true,
        };

        this.$nextTick(() => {
          this.Player.start(this.isBuy ? contentPayUrl : contentUrl);
          this.Player.play();
          this.setPlayerVideo(self, isAndroid, true);

          //         this.player.landscapeFullscreen({
          // 	fullscreen: {
          // 		enterOnRotate: true, //在横向旋转设备时进入全屏模式
          // 		alwaysInLandscapeMode: true, //即使设备处于纵向模式，也始终以横向模式进入全屏（适用于chromium、firefox和ie>=11）
          // 		iOS: true // 是否在iOS上使用假全屏（显示播放器控件而不是系统控件所需）
          // 	}
          // });
        });
      }
    },
    clear() {
      this.Player.destroy(true);
      this.Player = null;
    },
    /**
     * @description: 判断网络是否为wifi
     * @param {type} isWifi 网络状态
     * @return: isWifi 网络状态
     */
    isWifiFun() {
      let network_state = "";
      let ua = window.navigator.userAgent;
      let con = window.navigator.connection;
      // 如果是微信
      if (/MicroMessenger/.test(ua)) {
        // 如果是微信6.0以上版本，用UA来判断
        if (/NetType/.test(ua)) {
          var type = ua.match(/NetType\/(\S*)/);
          network_state = type[1];
          // 如果是微信6.0以下版本，调用微信私有接口WeixinJSBridge
        } else {
          document.addEventListener(
              "WeixinJSBridgeReady",
              function onBridgeReady() {
                WeixinJSBridge.invoke("getNetworkType", {}, function (e) {
                  network_state = e.err_msg;
                  console.log(e);
                });
              }
          );
        }
        // 如果支持navigator.connection
      } else if (con) {
        var network = con.type;
        network_state = network;
      }
      if (network_state == "WIFI") {
        this.isWifi = true;
      } else if (network_state == undefined) {
        this.isWifi = true;
      } else {
        this.$store.commit("changeWifi", false);
        this.isWifi = false;
      }
    },
    /**
     * @description:监听播放视频状态存到本地方法
     * @param {type} self:this locked:是否带锁 isAndroid:是否是安卓 muted:是否静音
     */
    setPlayerVideo(self, isAndroid, flag) {
      console.log(this.videoDetail);
      let isFood = this.videoDetail.isFood == "food";
      setTimeout(() => {
        // 当前视频的id
        let videoId = this.videoDetail.id;

        // 获取本地视频播放的时间
        let localcurrentTime = JSON.parse(
            localStorage.getItem("foodCurrentTime")
        )
            ? JSON.parse(localStorage.getItem("foodCurrentTime"))
            : {};
        // 新增视频唯一时间对象
        localcurrentTime.hasOwnProperty(videoId)
            ? localcurrentTime
            : (localcurrentTime[videoId] = 0);
        // 判断视频有没有开始播放 有控件的情况下不播放不会实例化video标签
        this.Player.once("playing", () => {
          this.$parent.playIndex = 0;
          // let times = true; //观看视频成长值任务
          let videoState = true; //判断视频是否播放完
          // 开始播放视频图片清空，并把控制器展示出来
          $("#child").css("background-image", "");
          $(".xgplayer-controls").css("opacity", "1");
          // 设置当前视频上次播放的时间
          let current = Number(localcurrentTime[videoId]);
          // this.Player.currentTime = current;
          // $('video').currentTime = current;
          // 非wifi环境弹窗
          console.log(this.isWifi);
          console.log("wifi情况");
          if (!this.isWifi) {
            this.$toast({
              duration: 3000,
              message: "当前为非Wi-Fi环境，请注意流量消耗",
              context: self,
            });
          }
          //  实时更新当前视频播放时间存到本地
          $("video").on("timeupdate", (e) => {
            if (!$("video")[0]) return false;
            this.currentTimebug = Math.ceil($("video")[0].currentTime);
            // if(this.currentTimebug>10&&this.player.fullscreen){
            //     this.player.exitFullscreen()
            // }
            localcurrentTime[videoId] = this.currentTimebug;
            window.localStorage.setItem(
                "foodCurrentTime",
                JSON.stringify(localcurrentTime)
            );
            // 判断是否注册
            if (this.currentTimebug >= 10 && self.Player.fullscreen) {
              //10秒 并且为全屏的时候
              if (isUserLogin()) {
                //是否登陆
                this.$emit("clearDestroy", 0); //0 10秒去判断登陆
              }
            } else if (
                this.currentTimebug >= 10 &&
                self.Player.fullscreen == false
            ) {
              //10秒并且不为全屏的时候
              self.listenLogin();
            }
            if (this.currentTimebug >= this.readingArticleDuration) {
              // 超过10秒存id到本地
              // if (this.currentTimebug >= 10) {
              if (localStorage.getItem("saveFoodGroth")) {
                let saveId = JSON.parse(localStorage.getItem("saveFoodGroth"));
                if (saveId.indexOf(self.videoDetail.id) == -1) {
                  saveId.push(self.videoDetail.id);
                  localStorage.setItem("saveFoodGroth", JSON.stringify(saveId));
                }
              } else {
                localStorage.setItem(
                    "saveFoodGroth",
                    JSON.stringify([self.videoDetail.id])
                );
              }
              // }

            }

            // 20秒弹出兑换框
            if (this.currentTimebug >= 20 && !this.isBuy) {
              this.Player.pause();
              this.Player.currentTime = 19;
              this.showExchangePoint = true;
            }
          });
        });

        this.Player.on("pause", () => {
          if (!$("video")[0]) return false;
          const num = this.currentTimebug;
          const total = Math.floor($("video")[0].duration);
          const percent = Math.round((num / total) * 10000) / 10000.0;
          const id = this.videoDetail.isPromotional
              ? "999"
              : this.videoDetail.id;
          this.$emit("playerBuriedpoint", {num, total, percent, id});
          // const time = this.videoDetail.videoDuration.split(":")[0] * 60 + this.videoDetail.videoDuration.split(":")[1] * 1 - 1
        });
        this.Player.on("ended", () => {
          this.$emit(
              "switchoverVideoNext",
              this.videoDetail.isPromotional ? "999" : this.videoDetail.id
          );
          this.Player.currentTime = 0;
          this.Player.pause();
        });
      }, 10);
    },
    //销毁video实例
    switchVideo() {
      this.Player.pause(); //暂停播放
      this.Player.destroy(true); //销毁实例
      this.Player = null; //清空实例
      this.createVideo(this.videoDetail); //初始化
    },
    addGroth() {
      // 观看视频10秒添加积分
      if (this.Player.fullscreen) {
        this.$emit("clearDestroy", 1); //1 10出去加积分
      }
      addIntegral({
        taskGroupCode: 'YDWZ00002',
        crmId: this.userInfo?.crm_id
      }, this, '播放视频任务完成')
    },
    initPlayer() {
      // if(this.Player){
      //   this.Player.destroy(true); //销毁实例
      //   this.Player = null; //清空实例
      //   this.createVideo(this.videoDetail); //初始化
      // }
      this.createVideo(this.videoDetail); //初始化

      //   this.Player.destroy(true); //销毁实例
      //   this.createVideo(this.videoDetail);
      $(".search_").css({"z-index": "1"}); //样式修改
    },
    getCookie,
    payPointConfirm(action, done) {
      if (action === "confirm") {
        API_.catipalDcotorPayNew(
            {crmId: until.getUserInfo(), id: this.videoDetail.id, unionId: getCookie("xmh_unionid")},
            (res) => {
              // if (
              //     this.getmotherState().currentPoint <
              //     this.masterrule[this.getmotherState().code]
              // ) {
              //   this.$toast("积分不足，无法观看");
              //   done();
              //   return false;
              // }
              if (res.code === 200) {
                this.showExchangePoint = false;
                done();
                this.$toast("兑换完成");
                this.videoDetail.videoUrl = res.data;
                this.videoDetail.pageCumulativeNum++;
                this.createVideo(this.videoDetail);
                this.$nextTick(() => {
                  this.Player.currentTime = 19;
                });
                sensors.track("Point_exchange", {
                  Membership_level: this.getmotherState().name,
                  content_title: this.videoDetail.name,
                });
              } else if(res.code === 507) {
                this.$toast("积分不足，无法观看");
                done();
              } else {
                this.$toast("兑换失败,请联系客服!");
                done();
              }
            }
        );
      } else {
        done();
      }
    },
    // 辅食上传图片
    getUpimg(fileList, callback) {
      console.log(fileList);
      if (fileList.length != 0) {
        var length = fileList.length;
        var formdata = new FormData();
        formdata.append("files", fileList);
        try {
          this.$http.post(
              "/upload/batchPictureFile",
              {ContentType: "application/x-www-form-urlencoded"},
              formdata,
              (res) => {
                if (res.code === "200") {
                  this.foodInitImg = this.foodInitImg.concat(res.data);
                  this.total = this.len - this.foodInitImg.length;
                  callback();
                } else if (res.code === "500") {
                  this.foodInitImg = [];
                  this.$toast({
                    message: "服务器异常，程序猿小哥哥正在努力修复~",
                    duration: 2000,
                  });
                } else {
                  this.foodInitImg = [];
                  this.$toast({
                    message: res.message,
                    duration: 2000,
                  });
                }
              }
          );
        } catch (err) {
          this.foodInitImg = [];
          if (err.code === "500") {
            this.$toast({
              message: "服务器异常，程序猿小哥哥正在努力修复~",
              duration: 2000,
            });
          } else {
            this.$toast({
              message: err.message,
              duration: 2000,
            });
          }
        }
      }
    },
    //调取微信上传
    getUpload() {
      let that = this;
      wxJsSet.getMoreAlbum(this, this.total, function (res) {
        that.uploadFoodImg(res);
      });
    },
    uploadFoodImg(data) {
      API.uploadImages({mediaId: data[0]}, {}, (res) => {
        if (res.code === "200") {
          this.foodInitImg.push(res.data);
          this.total = this.len - this.foodInitImg.length;
        }
      });
    },
    // 清除图片数组
    clearcommentPic() {
      this.total = this.len;
      this.foodInitImg = [];
    },
    getPiclen(num) {
      this.total = this.len - num;
    },
    comTotal(val) {
      this.commentTotal = val;
    },
  },
  activated() {
    if (this.showAllComment) {
      $(".van-overlay").css({display: "block"});
      this.Player.play();
    }
  },
  deactivated() {
    if (this.$route.path === "/replyComment" && this.isShowVedio) {
      console.log(this.$route);
      this.$parent.showVedio = true;
      this.showAllComment = true;
    }
  },
  components: {
    Xgplayer,
    allComment,
    commentField,
    commonent,
    HFshare,
    foodAllComment,
    foodCommentField,
  },
};
</script>

<style lang="less" scoped>
.food-box {
  width: 100% !important;
  overflow: hidden;
  z-index: 10000;
}

.childVideo {
  height: 100vh;
  width: 100%;
  position: relative;
  z-index: 50;
  // 哈佛视频样式
  .gobackBtn {
    position: absolute;
    left: 5px;
    top: 5px;
    z-index: 99;

    img {
      width: 28px;
      height: 28px;
    }
  }

  .common {
    height: 50%;
  }

  .introduce {
    position: absolute;
    z-index: 99;
    bottom: 60px;
    left: 14px;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
  }

  // 弹出全部评论样式
  .anchor {
    /deep/ .commentWrap {
      border: 100px;
      padding-bottom: 30px;
    }

    /deep/ .PublishComment {
      display: none;
    }
  }

  /deep/ .van-overlay {
    background: transparent;
  }

  .sendinfo {
    width: 50px;
    height: 30px;
    color: #fff;
    line-height: 30px;
    text-align: center;
    background: chocolate;
  }

  input {
    background: none;
    outline: none;
    border: none;
  }

  #child {
    position: absolute;
    width: 100% !important;
    height: 100% !important;
    background-size: 100% 100%;
    background-position: center center;
    z-index: 10;
  }

  .img {
    position: relative;

    .playNum {
      position: absolute;
      bottom: 8px;
      left: 10px;
      z-index: 11;
      color: #fff;
      font-size: 12px;
    }

    .time {
      position: absolute;
      bottom: 8px;
      right: 10px;
      color: #fff;
      z-index: 11;
      font-size: 12px;
    }
  }

  /deep/ .xgplayer-progress-cache {
    background: hsla(0, 0%, 100%, 0.1);
  }

  /deep/ .xgplayer-progress-played {
    background-image: linear-gradient(-90deg, #fff, #fff);
  }

  /deep/ .xgplayer-progress-outer {
    height: 2px;

    .xgplayer-progress-btn {
      width: 9px;
      height: 9px;
      top: -4px;
    }
  }

  .videoDisPlayer {
    /deep/ .xgplayer-start {
      display: none !important;
    }
  }
}

/deep/ .xgplayer-progress .xgplayer-progress-outer .xgplayer-progress-played {
  background: #e89f00;
}

/deep/ .xgplayer-skin-default .xgplayer-controls {
  background: transparent;
}

// /deep/ .xgplayer-skin-default .xgplayer-controls {
//   display: flex;
// }
/deep/ .xgplayer-volume {
  display: none !important;
}

/deep/ .xgplayer-progress {
  width: 65% !important;
  top: -3px !important;
  left: 79px !important;
}

/deep/ .xgplayer-time {
  span:nth-of-type(1)::after {
    content: "";
  }

  span:nth-of-type(1) {
    position: absolute;
    left: 39px;
    top: -13px;
  }

  span:nth-of-type(2) {
    top: -13px;
    position: absolute;
    right: 14px;
    color: #fff;
  }
}

/deep/ .xgplayer-play {
  top: -15px;
}

/deep/
.xgplayer-skin-default.xgplayer-mobile
.xgplayer-progress:hover
.xgplayer-progress-btn {
  top: -4px !important;
}

.height {
  height: 227px !important;
}

// /deep/ .xgplayer-skin-default video {
//   object-fit: fill !important;
// }
//  .xgplayer-skin-default  video {
//      object-fit: fill;
// }
/deep/ .xgplayer-skin-default .xgplayer-fullscreen .xgplayer-icon {
  display: none;
}

/deep/ .xgplayer-skin-default .xgplayer-poster {
  background-size: 100%;
  background-position: 50%;
  background-color: rgba(0, 0, 0, 1);
  background-repeat: no-repeat;
}
</style>
